import { cn } from '@/lib/utils';

interface Props {
  /** Pixel size of the round badge. */
  size?: number;
  /** Rising steam animation (the lid also lifts on hover of a parent `.group`). */
  animated?: boolean;
  className?: string;
}

/**
 * Brand mark: a serving cloche on a plate with steam rising — "something good is cooking".
 * Decorative only (aria-hidden); pair it with visible text such as the product name.
 */
export function RestaurantLogo({ size = 36, animated = true, className }: Props) {
  return (
    <span
      aria-hidden
      className={cn(
        'logo-badge relative grid shrink-0 place-items-center rounded-full bg-gradient-to-br from-brand-600 to-brand-800 text-white shadow-md shadow-brand-900/20',
        animated && 'logo-animated',
        className,
      )}
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 24 24"
        width={size * 0.66}
        height={size * 0.66}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Steam */}
        <g className="logo-steam">
          <path d="M8.5 7.5c-.9-1 .9-1.9 0-3" />
          <path d="M12 6.5c-.9-1 .9-1.9 0-3" />
          <path d="M15.5 7.5c-.9-1 .9-1.9 0-3" />
        </g>
        {/* Lid (dome + handle) */}
        <g className="logo-lid">
          <path d="M4.5 17.5a7.5 7.5 0 0 1 15 0" />
          <path d="M12 10V8.8" />
          <circle cx="12" cy="8.2" r="0.6" fill="currentColor" />
        </g>
        {/* Plate */}
        <path d="M2.5 17.5h19" />
        <path d="M5 20h14" opacity="0.6" />
      </svg>
    </span>
  );
}
